import {map, Observable} from 'rxjs';

import {Injectable, Signal} from '@angular/core';
import {BackendService, IGetValidationRuleListResponse, IValidationRule, IValidationRulesService} from '@core/api/data-access';

import {ValidationRulesStoreState} from '../+store';

import IValidationRulesState = ValidationRulesStoreState.IValidationRulesState;

/**
 * Service for managing validation rules through backend API.
 **/
@Injectable({
	providedIn: 'root',
	deps: [],
})
export class ValidationRulesService extends BackendService<IValidationRulesState> implements IValidationRulesService {
	// public allValidationRulesList$: Signal<Map<string, IValidationRule>> = this.store.selectSignal(selectAllValidationRulesMap);
	public allValidationRulesList$: Signal<Map<string, IValidationRule>> = null;
	// public enabledValidationRulesListMap$: Signal<Map<string, IValidationRule>> = this.store.selectSignal(selectEnabledValidationRulesMap);
	public enabledValidationRulesListMap$: Signal<Map<string, IValidationRule>> = null;

	/** Creates an instance of ValidationRulesService */
	constructor() {
		super('ValidationRules', {
			// store: {
			// storeKey: FeatureStoreNames.VALIDATION_RULES_FEATURE_KEY,
			// },
		});
	}

	/**
	 * Retrieves a list of validation rules from the backend.
	 *
	 * @returns An Observable of IValidationRule[] representing the list of validation rules.
	 */
	public getValidationRulesList(): Observable<IValidationRule[]> {
		return this.apiService.get<IGetValidationRuleListResponse>(this.getUrl('list')).pipe(map(response => response.validationRules));
	}

	/**
	 * Adds a new validation rule through the backend API.
	 *
	 * @param metaTag - The validation rule to be added.
	 * @returns An Observable of IValidationRule representing the added validation rule.
	 */
	public addValidationRule(metaTag: IValidationRule): Observable<IValidationRule> {
		return this.apiService.post<object, IValidationRule>(this.getUrl('rule'), metaTag).pipe(map(() => metaTag));
	}

	/**
	 * Deletes a validation rule with the specified key from the backend.
	 *
	 * @param metaTagKey - The key of the validation rule to be deleted.
	 * @returns An Observable of {} representing a successful deletion.
	 */
	public deleteValidationRule(metaTagKey: string): Observable<object> {
		return this.apiService.delete<object>(this.getUrl('rule'), {key: metaTagKey}).pipe(map(() => ({})));
	}

	/**
	 * Updates an existing validation rule through the backend API.
	 *
	 * @param metaTag - The updated validation rule.
	 * @returns An Observable of IValidationRule representing the updated validation rule.
	 */
	public updateValidationRule(metaTag: IValidationRule): Observable<IValidationRule> {
		return this.apiService.put<object, IValidationRule>(this.getUrl('rule'), metaTag).pipe(map(() => metaTag));
	}
}
